/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * @min 0
 * @max 65535
 */
export type U16 = number;

export interface MatterFabricList {
  /** commissioned fabrics in the target Matter device */
  fabrics: FabricDescriptor[];
  /**
   * the maximum number of fabrics that can be commissioned in the target Matter device
   * @min 5
   * @max 255
   */
  supportedFabrics: number;
  /** the index of the fabric in the target Matter device over which the hub is connected */
  currentFabricIndex: FabricIndex;
}

export interface MatterOperationalServiceList {
  /** operational service records for Matter nodes */
  nodes?: OperationalInstanceName[];
}

export interface MatterMigrationFabricRecord {
  /** the fabric's Root Certificate Authority public key */
  rootPublicKey: EllipticCurvePublicKey;
  /** the compressed ID of the given fabric */
  compressedFabricId: CompressedFabricId;
  /** the ID of the given fabric */
  fabricId: FabricId;
  /** the hub's node ID within the fabric */
  nodeId: NodeId;
}

export interface MatterNodeMigrationStatus {
  /** 64-bit compressed fabric ID and 64-bit operational node ID, each expressed in ASCII-hexadecimal-format with leading zeroes, separated by a hyphen */
  node?: OperationalInstanceName;
  status?: 'PENDING' | 'MIGRATED' | 'FAILED';
}

export interface MatterNodeMigrationStatusList {
  /** migration status for a collection of nodes */
  nodes?: MatterNodeMigrationStatus[];
}

export type CreateMatterFabricOperationalServiceEnumerationResponse = MatterOperationalServiceList;

export interface CreateMatterNodeMigrationCsrResponse {
  /** A PKCS#10 Certificate Signing Request in PEM format. */
  csr: CertificateSigningRequest;
}

export type GetMatterNodeMigrationFabricResponse = MatterMigrationFabricRecord;

export interface CreateMatterNodeMigrationFabricRequest {
  /** 64-bit fabric ID in ASCII-hexidecimal-format with leading zeroes, excluding reserved value 0 */
  fabricId: FabricId;
  /** 64-bit operational node ID in ASCII-hexidecimal-format with leading zeroes, excluding reserved values */
  nodeId: NodeId;
  /** An X.509v3 certificate in PEM format */
  nodeCertificate: Certificate;
  /** An X.509v3 certificate in PEM format */
  rootCA: Certificate;
  /**
   * A list of all intermediates certificate between the root and the node certificate.
   * @minItems 0
   */
  intermediateCA: Certificate[];
  /**
   * An array of Identity Protection Keys (IPKs) used within a fabric, which when fully populated represent
   * (previous, current, future) epoch keys.  To enable key rotation, nodes initiate CASE with the current key
   * and accept CASE with any of the previous, current, or future keys.  If two keys are presented, these are
   * (current, future).  If one key is presented, this is the (current) epoch key.  All APIs currently return
   * only a single (current) epoch key.
   */
  ipk: IdentityProtectionEpochKeys;
  /** The node identifier for the default administrator(s) on a fabric.  Typically, this embeds a CASE Authenticated Tag that administrators carry as an additional Relative Distinguished Name within their Node Operational Certificates. */
  adminSubject: AdminSubject;
}

export type CreateMatterNodeMigrationRequest = MatterOperationalServiceList;

export interface CreateMatterNodeMigrationResponse {
  /**
   * a unique identifier that can be used to poll the status of the node migration resource
   * @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$
   */
  migrationId?: string;
}

export type GetMatterNodeMigrationStatusResponse = MatterNodeMigrationStatusList;

export interface CreateMatterCommissioningWindowRequest {
  /**
   * the number of seconds for which to open the commissioning window
   * @min 180
   * @max 900
   */
  commissioningTimeout: number;
}

export interface CreateMatterCommissioningWindowResponse {
  /**
   * base38-encoded Matter onboarding payload with MT QR code prefix
   * @pattern ^MT:[0-9A-Z-.]+$
   * @example "MT:8IXS142C00KA0648G00"
   */
  onboardingPayload: string;
  /**
   * an 11 or 21-digit decimal numeric string
   * @pattern ^[0-9]{11}([0-9]{10})?$
   * @example "34970112332"
   */
  manualPairingCode: string;
}

export interface PartialUpdateMatterFabricRequest {
  /** the new label to set for the hub-connected fabric */
  fabricLabel: FabricLabel;
}

/**
 * @pattern ^[0-9a-f:/]{5,43}$
 * @example "fd5c:ef9c:acd5:55c9::/64"
 */
export type IpV6Prefix = string;

/**
 * @min 11
 * @max 26
 * @example 20
 */
export type ThreadChannel = number;

/**
 * @pattern ^[0-9a-f]{16}$
 * @example "357351e001eb4ba3"
 */
export type ThreadExtendedPanId = string;

/**
 * @pattern ^[0-9a-f]{32}$
 * @example "00112233445566778899aabbccddeeff"
 */
export type ThreadNetworkKey = string;

/**
 * @minLength 1
 * @maxLength 16
 * @example "SmartThings"
 */
export type ThreadNetworkName = string;

/**
 * @pattern ^[0-9a-f]{32}$
 * @example "d54a302098c3adb116c5fd2137771d56"
 */
export type ThreadPskc = string;

/**
 * 64-bit IEEE 802.15.4 Extended Address of Thread interface
 * @pattern ^[0-9a-f]{16}$
 * @example "d60aba249cbcbd25"
 */
export type ThreadExtendedAddress = string;

/**
 * @pattern ^[0-9a-f]{16}$
 * @example "8a6c8146b66fc487"
 */
export type ThreadBorderAgentDiscriminator = string;

export interface ThreadNetworkInfo {
  /**
   * @pattern ^[0-9]{0,20}$
   * @example "1"
   */
  activeTimestamp: string;
  channel: ThreadChannel;
  extendedPanId: ThreadExtendedPanId;
  meshLocalPrefix: IpV6Prefix;
  networkKey: ThreadNetworkKey;
  networkName: ThreadNetworkName;
  panId: U16;
  pskc: ThreadPskc;
  /** 64-bit IEEE 802.15.4 Extended Address of Thread interface */
  extendedAddress: ThreadExtendedAddress;
}

export interface ThreadNetworkJoinInfo {
  channel: ThreadChannel;
  extendedPanId: ThreadExtendedPanId;
  networkKey: ThreadNetworkKey;
  panId: U16;
}

export interface ThreadMeshcopRecord {
  /**
   * @minLength 1
   * @maxLength 3
   * @example "1"
   */
  recordVersion: string;
  /**
   * @pattern ^[0-9]+\.[0-9]+\.[0-9]+$
   * @example "1.3.0"
   */
  threadVersion: string;
  /**
   * @minLength 2
   * @maxLength 24
   * @example "OpenThread"
   */
  vendorName: string;
  /**
   * @minLength 1
   * @maxLength 24
   * @example "BorderRouter"
   */
  productName: string;
  networkName: ThreadNetworkName;
  extendedPanId: ThreadExtendedPanId;
  borderAgentDiscriminator: ThreadBorderAgentDiscriminator;
}

export interface ThreadBorderRouterScanResults {
  borderRouters: ThreadMeshcopRecord[];
}

export interface ThreadOperationalDataSet {
  /**
   * @pattern ^[0-9a-f]{204}$
   * @example "0e080000000000000000000300000f35060004001fffe0020811111111222222220708fdacd1d8ab33adda051000112233445566778899aabbccddeeff030b536d6172745468696e6773010204d20410d54a302098c3adb116c5fd2137771d560c0402a0fff8"
   */
  operationalDataSet: string;
}

/** @format ^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$ */
export type Uuid = string;

/** @format date-time */
export type DateTime = string;

export type JsonValue = any;

export interface Devices {
  items?: DeviceItem[];
}

export interface DeviceItem {
  deviceId?: Uuid;
  locationId?: Uuid;
}

export interface DeviceStatuses {
  items?: DeviceStatusItem[];
}

export interface DeviceStatusItem {
  deviceId?: Uuid;
  locationId?: Uuid;
  componentId?: string;
  capabilityId?: string;
  attributeName?: string;
  value?: JsonValue;
  valueType?: 'number' | 'integer' | 'string' | 'object' | 'array' | 'unknown';
  unit?: string;
  data?: JsonValue;
  timestamp?: DateTime;
}

export interface HealthStatuses {
  items?: HealthStatusItem[];
}

export interface HealthStatusItem {
  deviceId?: Uuid;
  state?: DeviceHealthState;
  lastUpdatedDate?: DateTime;
  locationId?: Uuid;
}

export type ComponentStatus = Record<string, JsonValue>;

export interface CapabilityStatus {
  attributeName?: string;
  value?: JsonValue;
}

export interface HealthState {
  state?: DeviceHealthState;
  lastUpdatedDate?: DateTime;
}

export interface DeviceStatus {
  components?: Record<string, ComponentStatus>;
  HealthState?: HealthState;
}

export interface LocalApiCommandBatch {
  commands?: LocalApiCommand[];
}

export interface LocalApiCommand {
  component?: string;
  capability?: string;
  command?: string;
  arguments?: JsonValue[];
}

export enum DeviceHealthState {
  ONLINE = 'ONLINE',
  OFFLINE = 'OFFLINE',
  UNKNOWN = 'UNKNOWN',
}

export enum RespCommandResultStatus {
  ACCEPTED = 'ACCEPTED',
  FAILED = 'FAILED',
}

export interface RespCommandResult {
  id?: Uuid;
  status?: RespCommandResultStatus;
}

export interface RespCommandResults {
  results?: RespCommandResult[];
}

export interface Reboot {
  items?: Reboot[];
}

/** Factory reset data */
export interface FactoryResetData {
  resetType?: ResetType;
}

export enum ResetType {
  SOFT = 'SOFT',
  HARD = 'HARD',
}

/** The device OTA configuration of a hub */
export interface DeviceOtaConfigurationStatus {
  /** True if hub supports Over The Air device firmware updates */
  supported?: boolean;
  /** True if hub has enabled Over The Air device firmware updates */
  enabled?: boolean;
  /** True if hub supports Over The Air device firmware updates for lights in particular */
  lightsEnabled?: boolean;
}

/** Set Device OTA configuration for a hub */
export interface DeviceOtaConfigurationSetting {
  /** Set to true to enable Over The Air device firmware updates for a hub */
  enabled?: boolean;
  /** Set to true to enable Over The Air device firmware updates for lights in particular for a hub */
  lightsEnabled?: boolean;
}

/** The hub's WI-FI link information. */
export interface WifiLinkInfo {
  /** True if there is a valid link to the WI-FI access point. */
  connected: boolean;
  /** An array of integers which contains up to 32 octets of arbitrary content representing SSID characters in a byte sequence. */
  ssid?: number[];
  /** An array of integers which represents the 48-bit identifier for basic service set. */
  bssid?: number[];
  /** The decibel milliwatts representing Received Signal Strength. */
  rssiDbm?: number;
  /** The frequency used by the WI-FI access point in kiloHertz. */
  frequencyKhz?: number;
  /** The receiving bitrate of the WI-FI access point in kilobits per second. */
  rxBitrateKbps?: number;
  /** The transmit bitrate of the WI-FI access point in kilobits per second. */
  txBitrateKbps?: number;
}

/**
 * Zigbee Extended Unique Identifier
 * @format ^[0-9A-F]{16}$
 */
export type ZigbeeEui = string;

/**
 * @pattern ^[0-9a-fA-F]{16}$
 * @example "02B0D8DD6BB0E9C0"
 */
export type ZigbeeExtendedPanId = string;

/** The Zigbee radio channel for a hub */
export interface ZigbeeRadioChannelObject {
  /** Zigbee radio channel */
  channel?: ZigbeeRadioChannel;
}

/**
 * Zigbee radio channel
 * @min 11
 * @max 26
 * @example 20
 */
export type ZigbeeRadioChannel = number;

/** The Zigbee Secure Mode setting for a hub */
export interface ZigbeeSecureMode {
  /** True if the hub permits Zigbee unsecure rejoin */
  unsecureRejoinEnabled?: boolean;
}

/** The Zigbee network state for a hub */
export interface ZigbeeNetworkState {
  /**
   * Zigbee network states:
   *   * `UNKNOWN` - Unknown state
   *   * `INITIALIZING` - Radio initializing
   *   * `DOWN` - Radio down
   *   * `UP` - Radio up
   *   * `DISABLED` - Zigbee disabled
   */
  state?: 'UNKNOWN' | 'INITIALIZING' | 'DOWN' | 'UP' | 'DISABLED';
}

export interface ZwaveStartExclude {
  /**
   * The number of seconds to wait before stopping exclusion
   * @format int64
   * @min 0
   */
  timeoutSeconds?: number;
}

export interface JoinPrimaryData {
  zigbee?: JoinPrimaryZigbeeData;
  thread?: JoinPrimaryThreadData;
}

export interface JoinPrimaryZigbeeData {
  /** Zigbee radio channel */
  channel: ZigbeeRadioChannel;
  panId: U16;
  extendedPanId: ZigbeeExtendedPanId;
}

export interface JoinPrimaryThreadData {
  channel: ThreadChannel;
  panId: U16;
  extendedPanId: ThreadExtendedPanId;
  networkKey: ThreadNetworkKey;
}

export interface JoinSecondaryData {
  zigbee?: JoinSecondaryZigbeeData;
}

export interface JoinSecondaryZigbeeData {
  installationCode: ZigbeeInstallCode;
  /** Zigbee Extended Unique Identifier */
  euid: ZigbeeEui;
}

export interface ConvertToSecondaryData {
  primaryHubDeviceId: string;
  joinPrimaryData: JoinPrimaryData;
}

export enum SecondaryConversionState {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export enum SecondaryReversionState {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
}

/** Identifies the type of error. Included when state is FAILED. */
export enum SecondaryError {
  ZIGBEE = 'ZIGBEE',
  THREAD = 'THREAD',
  INTERNAL = 'INTERNAL',
}

export interface SecondaryConversionStatusResponse {
  state: SecondaryConversionState;
  /** This is null when the state is NOT_STARTED and otherwise it is the device id of the primary hub */
  primaryHubDeviceId?: string;
  /** Identifies the type of error. Included when state is FAILED. */
  error?: SecondaryError;
  /** English description of the error. Included when state is FAILED. */
  errorDetails?: string;
}

export interface SecondaryReversionStatusResponse {
  state: SecondaryReversionState;
}

export type ZigbeeInstallCode = string;

export interface CreateReplaceFetchBackupRequest {
  backupUrl: string;
}

/** identifies each of the expected states for a hub replace operation */
export enum ReplacementStatus {
  NOT_STARTED = 'NOT_STARTED',
  PREPARED = 'PREPARED',
  BACKUP_UPLOADED = 'BACKUP_UPLOADED',
  FETCHING_BACKUP = 'FETCHING_BACKUP',
  VALIDATING_BACKUP = 'VALIDATING_BACKUP',
  BACKUP_VALIDATED = 'BACKUP_VALIDATED',
  APPLYING_BACKUP = 'APPLYING_BACKUP',
  BACKUP_APPLIED = 'BACKUP_APPLIED',
  RUNNING = 'RUNNING',
  COMPLETE = 'COMPLETE',
  FAILED = 'FAILED',
}

/** identifies the role for a hub in the hub replace operation */
export enum HubReplaceControllerType {
  SOURCE_HUB = 'SOURCE_HUB',
  DESTINATION_HUB = 'DESTINATION_HUB',
}

/**
 * This object represents the status of a single hub's backup or replace operation. If the status
 * property is set `Failure` then the `failureInfo` property will be populated with additional
 * details. For all other statuses this is expected to be undefined
 */
export interface GetReplaceStatusResponseBody {
  /** identifies each of the expected states for a hub replace operation */
  status: ReplacementStatus;
  /** Details about the error. */
  failureInfo?: Error;
  correlationId?: string;
  /** identifies the role for a hub in the hub replace operation */
  controllerType: HubReplaceControllerType;
}

export interface ErrorResponse {
  /**
   * A correlation id used for reference when contacting support.
   * @example "7b8514e6-230d-41cc-b3c2-512bca15abf0"
   */
  requestId?: string;
  /** Details about the error. */
  error?: Error;
}

/** Details about the error. */
export interface Error {
  /**
   * Machine-readable error code.
   * @example "ConstraintViolationError"
   */
  code?: string;
  /**
   * Human-readable error message.
   * @example "The request was malformed."
   */
  message?: string;
  /**
   * Optional field used to point to a problematic part of the request.
   * @example "31192dc9-eb45-4d90-b606-21e9b66d8c2b"
   */
  target?: string;
  details?: Error[];
}

/**
 * The node identifier for the default administrator(s) on a fabric.  Typically, this embeds a CASE Authenticated Tag that administrators carry as an additional Relative Distinguished Name within their Node Operational Certificates.
 * @format ^(((?!0{16})(?!F{7}[0-9A-F]{9})[0-9A-F]{16})|(F{7}D[0-9A-F]{8}))$
 */
export type AdminSubject = string;

/**
 * An X.509v3 certificate in PEM format
 * @example "-----BEGIN CERTIFICATE-----\nMIIB4TCCAYagAwIBAgIIGOlpug4IniMwCgYIKoZIzj0EAwIwIjEgMB4GCisGAQQB\ngqJ8AQMMEENBQ0FDQUNBMDAwMDAwMDMwHhcNMjAxMDE1MTQyMzQzWhcNNDAxMDE1\nMTQyMzQyWjBEMSAwHgYKKwYBBAGConwBAQwQREVERURFREUwMDAxMDAwMTEgMB4G\nCisGAQQBgqJ8AQUMEEZBQjAwMDAwMDAwMDAwMUQwWTATBgcqhkjOPQIBBggqhkjO\nPQMBBwNCAAS89lgNLXHhRBZlH3wxG178+a7AqMEK+AknhEwkD1Go6yP6B0QTiIes\nHnPLcqBUtqDbBiKqgHBxAWMTsVlshVLPo4GDMIGAMAwGA1UdEwEB/wQCMAAwDgYD\nVR0PAQH/BAQDAgeAMCAGA1UdJQEB/wQWMBQGCCsGAQUFBwMCBggrBgEFBQcDATAd\nBgNVHQ4EFgQUaWfJEvij5olVb4mbZddvU/plx7YwHwYDVR0jBBgwFoAURAzGkjHE\ny1s3lCQm+Bu+JLfvNFwwCgYIKoZIzj0EAwIDSQAwRgIhAM5u85PLvJT4DuKQyzw9\nNzM1urlZB3NNmdOEpio3O4SEAiEA4dQaBMMUD6oZ6KK5mwxh4zwn6pE5c+RbW8bj\nnCcNrFM=\n-----END CERTIFICATE-----\n"
 */
export type Certificate = string;

/**
 * A PKCS#10 Certificate Signing Request in PEM format.
 * @example "-----BEGIN CERTIFICATE REQUEST-----\nMIIBADCBpwIBADBFMQswCQYDVQQGEwJVUzETMBEGA1UECAwKU29tZS1TdGF0ZTEh\nMB8GA1UECgwYSW50ZXJuZXQgV2lkZ2l0cyBQdHkgTHRkMFkwEwYHKoZIzj0CAQYI\nKoZIzj0DAQcDQgAEvPZYDS1x4UQWZR98MRte/PmuwKjBCvgJJ4RMJA9RqOsj+gdE\nE4iHrB5zy3KgVLag2wYiqoBwcQFjE7FZbIVSz6AAMAoGCCqGSM49BAMCA0gAMEUC\nIDrLfK17+sA13XHWPfBx5sNrPueinoaju2F0cTea8fBvAiEA5+Vij6HcVjZCs78o\nU1w5n0kGTkwyCjOvN/IRUFOezTg=\n-----END CERTIFICATE REQUEST-----\n"
 */
export type CertificateSigningRequest = string;

/**
 * 64-bit compressed fabric ID (hash of root public key and fabric ID) in ASCII-hexidecimal-format with leading zeroes
 * @pattern ^[0-9A-F]{16}$
 * @example "CAB195B90CDBCA9C"
 */
export type CompressedFabricId = string;

/**
 * Elliptic curve encryption public key in compressed form with prefix byte 0x04 followed by two 256-bit key points
 * @format byte
 * @pattern ^[A-Za-z0-9+/]{87}=$
 * @example "BDUoxoH1N+PlHpJGWYkXNxmQj27RPZEvOQFAotMUVrh2Rpvpg5uRjWQySxZUcAMARHWvCb2srv0FAnn1B4r8b68="
 */
export type EllipticCurvePublicKey = string;

export interface FabricDescriptor {
  /** the stable fabric index of the given fabric */
  fabricIndex: FabricIndex;
  /** the vendor ID of the fabric commissioner */
  vendorId: VendorId;
  /** the root CA public key for the given fabric */
  rootPublicKey: EllipticCurvePublicKey;
  /** the compressed fabric ID for the given fabric */
  compressedFabricId: CompressedFabricId;
  /** the ID of the fabric */
  fabricId: FabricId;
  /** the ID of the node within the fabric */
  nodeId: NodeId;
  /** the textual label of the fabric */
  fabricLabel: FabricLabel;
}

/**
 * 64-bit fabric ID in ASCII-hexidecimal-format with leading zeroes, excluding reserved value 0
 * @pattern ^(?!0{16})[0-9A-F]{16}$
 * @example "DBBD152AC71F134D"
 */
export type FabricId = string;

/**
 * @min 1
 * @max 255
 */
export type FabricIndex = number;

/**
 * @minLength 1
 * @maxLength 32
 * @example "SmartThings"
 */
export type FabricLabel = string;

/**
 * A symmetric key used to obfuscate Matter node identities during CASE handshake.
 * @format ^[0-9A-F]{32}$
 */
export type IdentityProtectionKey = string;

/**
 * An array of Identity Protection Keys (IPKs) used within a fabric, which when fully populated represent
 * (previous, current, future) epoch keys.  To enable key rotation, nodes initiate CASE with the current key
 * and accept CASE with any of the previous, current, or future keys.  If two keys are presented, these are
 * (current, future).  If one key is presented, this is the (current) epoch key.  All APIs currently return
 * only a single (current) epoch key.
 * @maxItems 1
 * @minItems 1
 */
export type IdentityProtectionEpochKeys = IdentityProtectionKey[];

/**
 * 64-bit operational node ID in ASCII-hexidecimal-format with leading zeroes, excluding reserved values
 * @pattern ^(?!0{16})(?!F{7}[0-9A-F]{9})[0-9A-F]{16}$
 * @example "E24BD96D4F235823"
 */
export type NodeId = string;

/**
 * 64-bit compressed fabric ID and 64-bit operational node ID, each expressed in ASCII-hexadecimal-format with leading zeroes, separated by a hyphen
 * @pattern ^[0-9A-F]{16}-(?!0{16})(?!F{7}[0-9A-F]{9})[0-9A-F]{16}$
 * @example "CAB195B90CDBCA9C-E24BD96D4F235823"
 */
export type OperationalInstanceName = string;

/**
 * @min 0
 * @max 65524
 * @example 4362
 */
export type VendorId = number;

export interface PostStopReplacementPayload {
  errorDetails?: string;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, 'body' | 'bodyUsed'>;

export interface FullRequestParams extends Omit<RequestInit, 'body'> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<FullRequestParams, 'body' | 'method' | 'query' | 'path'>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, 'baseUrl' | 'cancelToken' | 'signal'>;
  securityWorker?: (securityData: SecurityDataType | null) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown> extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = 'application/json',
  FormData = 'multipart/form-data',
  UrlEncoded = 'application/x-www-form-urlencoded',
  Text = 'text/plain',
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = '//hedge';
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>['securityWorker'];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) => fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: 'same-origin',
    headers: {},
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === 'number' ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join('&');
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter((key) => 'undefined' !== typeof query[key]);
    return keys
      .map((key) => (Array.isArray(query[key]) ? this.addArrayQueryParam(query, key) : this.addQueryParam(query, key)))
      .join('&');
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : '';
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === 'object' || typeof input === 'string') ? JSON.stringify(input) : input,
    [ContentType.Text]: (input: any) => (input !== null && typeof input !== 'string' ? JSON.stringify(input) : input),
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === 'object' && property !== null
            ? JSON.stringify(property)
            : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(params1: RequestParams, params2?: RequestParams): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (cancelToken: CancelToken): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === 'boolean' ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(`${baseUrl || this.baseUrl || ''}${path}${queryString ? `?${queryString}` : ''}`, {
      ...requestParams,
      headers: {
        ...(requestParams.headers || {}),
        ...(type && type !== ContentType.FormData ? { 'Content-Type': type } : {}),
      },
      signal: cancelToken ? this.createAbortSignal(cancelToken) : requestParams.signal,
      body: typeof body === 'undefined' || body === null ? null : payloadFormatter(body),
    }).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await (responseFormat !== 'json'
          ? response[responseFormat]()
          : response.text().then((text) => {
              try {
                return JSON.parse(text);
              } catch (e) {
                return text;
              }
            })
        )
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title Hub Edge API server
 * @version 1.0.0
 * @baseUrl //hedge
 */
export class HedgeApi<SecurityDataType extends unknown> extends HttpClient<SecurityDataType> {
  util = {
    /**
     * @description Ping the hub to see if it is available.
     *
     * @tags util
     * @name GetPing
     * @request GET:/util/ping
     * @secure
     */
    getPing: (params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/util/ping`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Reboot the hub if capable.
     *
     * @tags util
     * @name Reboot
     * @request POST:/util/reboot
     * @secure
     */
    reboot: (params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/util/reboot`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Initiate a factory reset
     *
     * @tags util
     * @name FactoryReset
     * @request POST:/util/factoryReset
     * @secure
     */
    factoryReset: (FactoryResetData: FactoryResetData, params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/util/factoryReset`,
        method: 'POST',
        body: FactoryResetData,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  config = {
    /**
     * @description Gets OTA support, current enabled OTA status, and lights enabled status for a given hub
     *
     * @tags config
     * @name GetOtaConfiguration
     * @request GET:/config/deviceOta
     * @secure
     */
    getOtaConfiguration: (params: RequestParams = {}) =>
      this.request<DeviceOtaConfigurationStatus, ErrorResponse>({
        path: `/config/deviceOta`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Sets OTA firmware update device support for hub and lights
     *
     * @tags config
     * @name SetOtaConfiguration
     * @request POST:/config/deviceOta
     * @secure
     */
    setOtaConfiguration: (DeviceOtaConfigurationSetting: DeviceOtaConfigurationSetting, params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/config/deviceOta`,
        method: 'POST',
        body: DeviceOtaConfigurationSetting,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),
  };
  wifi = {
    /**
     * @description Get wifi link info for hub.
     *
     * @tags wifi
     * @name GetWifiLinkInfo
     * @request GET:/wifi/linkInfo
     * @secure
     */
    getWifiLinkInfo: (params: RequestParams = {}) =>
      this.request<WifiLinkInfo, ErrorResponse>({
        path: `/wifi/linkInfo`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  multihub = {
    /**
     * @description | Get a primary hub's join data which is needed for a secondary hub to | join this hub's mesh networks
     *
     * @tags multihub
     * @name GetMultiHubJoinPrimaryData
     * @request GET:/multihub/joinPrimaryData
     * @secure
     */
    getMultiHubJoinPrimaryData: (params: RequestParams = {}) =>
      this.request<JoinPrimaryData, ErrorResponse>({
        path: `/multihub/joinPrimaryData`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get information necessary to add this hub to the primary hub's mesh networks
     *
     * @tags multihub
     * @name GetMultiHubJoinSecondaryData
     * @request GET:/multihub/joinSecondaryData
     * @secure
     */
    getMultiHubJoinSecondaryData: (params: RequestParams = {}) =>
      this.request<JoinSecondaryData, ErrorResponse>({
        path: `/multihub/joinSecondaryData`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Request that a hub begin the conversion to a secondary hub
     *
     * @tags multihub
     * @name PostConvertToSecondary
     * @request POST:/multihub/convertToSecondary
     * @secure
     */
    postConvertToSecondary: (ConvertToSecondaryData: ConvertToSecondaryData, params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/multihub/convertToSecondary`,
        method: 'POST',
        body: ConvertToSecondaryData,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the state of a hub's conversion into a secondary hub
     *
     * @tags multihub
     * @name GetConvertToSecondaryStatus
     * @request GET:/multihub/convertToSecondaryStatus
     * @secure
     */
    getConvertToSecondaryStatus: (params: RequestParams = {}) =>
      this.request<SecondaryConversionStatusResponse, ErrorResponse>({
        path: `/multihub/convertToSecondaryStatus`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags multihub
     * @name PostRevertFromSecondary
     * @request POST:/multihub/revertFromSecondary
     * @secure
     */
    postRevertFromSecondary: (params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/multihub/revertFromSecondary`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * No description
     *
     * @tags multihub
     * @name GetRevertFromSecondaryStatus
     * @request GET:/multihub/revertFromSecondaryStatus
     * @secure
     */
    getRevertFromSecondaryStatus: (params: RequestParams = {}) =>
      this.request<SecondaryReversionStatusResponse, ErrorResponse>({
        path: `/multihub/revertFromSecondaryStatus`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  zigbee = {
    /**
     * @description Get Zigbee Secure Mode state
     *
     * @tags zigbee
     * @name GetZigbeeSecureMode
     * @request GET:/zigbee/secureMode
     * @secure
     */
    getZigbeeSecureMode: (params: RequestParams = {}) =>
      this.request<ZigbeeSecureMode, ErrorResponse>({
        path: `/zigbee/secureMode`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Sets Zigbee unsecure rejoin state
     *
     * @tags zigbee
     * @name SetZigbeeSecureMode
     * @request POST:/zigbee/secureMode
     * @secure
     */
    setZigbeeSecureMode: (ZigbeeSecureMode: ZigbeeSecureMode, params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/zigbee/secureMode`,
        method: 'POST',
        body: ZigbeeSecureMode,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get integer value for Zigbee radio channel (11-25)
     *
     * @tags zigbee
     * @name GetZigbeeRadioChannel
     * @request GET:/zigbee/channel
     * @secure
     */
    getZigbeeRadioChannel: (params: RequestParams = {}) =>
      this.request<ZigbeeRadioChannelObject, ErrorResponse>({
        path: `/zigbee/channel`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Set integer value for Zigbee radio channel (11-25)
     *
     * @tags zigbee
     * @name SetZigbeeRadioChannel
     * @request POST:/zigbee/channel
     * @secure
     */
    setZigbeeRadioChannel: (ZigbeeChannel: ZigbeeRadioChannelObject, params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/zigbee/channel`,
        method: 'POST',
        body: ZigbeeChannel,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get Zigbee network state for hub.
     *
     * @tags zigbee
     * @name GetZigbeeNetworkState
     * @request GET:/zigbee/state
     * @secure
     */
    getZigbeeNetworkState: (params: RequestParams = {}) =>
      this.request<ZigbeeNetworkState, ErrorResponse>({
        path: `/zigbee/state`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  zwave = {
    /**
     * @description Initiates Z-Wave network repair for hub
     *
     * @tags zwave
     * @name ZwaveStartRepair
     * @request POST:/zwave/repair/start
     * @secure
     */
    zwaveStartRepair: (params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/zwave/repair/start`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Stops existing Z-Wave network repair for hub
     *
     * @tags zwave
     * @name ZwaveStopRepair
     * @request POST:/zwave/repair/stop
     * @secure
     */
    zwaveStopRepair: (params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/zwave/repair/stop`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Start Z-Wave exclusion for hub
     *
     * @tags zwave
     * @name ZwaveStartExclude
     * @request POST:/zwave/exclude/start
     * @secure
     */
    zwaveStartExclude: (ZwaveStartExclude: ZwaveStartExclude, params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/zwave/exclude/start`,
        method: 'POST',
        body: ZwaveStartExclude,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Stop currently executing exclusion
     *
     * @tags zwave
     * @name ZwaveStopExclude
     * @request POST:/zwave/exclude/stop
     * @secure
     */
    zwaveStopExclude: (params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/zwave/exclude/stop`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  devices = {
    /**
     * @description Get a list of devices known to this hub that can support local execution.
     *
     * @tags devices
     * @name GetDevices
     * @request GET:/devices
     * @secure
     */
    getDevices: (params: RequestParams = {}) =>
      this.request<Devices, ErrorResponse>({
        path: `/devices`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the status for all devices known to this hub.
     *
     * @tags devices
     * @name GetDevicesStatus
     * @request GET:/devices/status
     * @secure
     */
    getDevicesStatus: (params: RequestParams = {}) =>
      this.request<DeviceStatuses, ErrorResponse>({
        path: `/devices/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the health status for all devices known to this hub.
     *
     * @tags devices
     * @name GetDevicesHealth
     * @request GET:/devices/health
     * @secure
     */
    getDevicesHealth: (params: RequestParams = {}) =>
      this.request<HealthStatuses, ErrorResponse>({
        path: `/devices/health`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the status for a single device.
     *
     * @tags devices
     * @name GetDeviceStatus
     * @request GET:/devices/{deviceId}/status
     * @secure
     */
    getDeviceStatus: (deviceId: string, params: RequestParams = {}) =>
      this.request<DeviceStatus, ErrorResponse>({
        path: `/devices/${deviceId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the status for a device component.
     *
     * @tags devices
     * @name GetComponentStatus
     * @request GET:/devices/{deviceId}/components/{componentId}/status
     * @secure
     */
    getComponentStatus: (deviceId: string, componentId: string, params: RequestParams = {}) =>
      this.request<ComponentStatus, ErrorResponse>({
        path: `/devices/${deviceId}/components/${componentId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the capability status for a device component.
     *
     * @tags devices
     * @name GetCapabilityStatus
     * @request GET:/devices/{deviceId}/components/{componentId}/capabilities/{capabilityId}/status
     * @secure
     */
    getCapabilityStatus: (deviceId: string, componentId: string, capabilityId: string, params: RequestParams = {}) =>
      this.request<CapabilityStatus, ErrorResponse>({
        path: `/devices/${deviceId}/components/${componentId}/capabilities/${capabilityId}/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Execute device commands.
     *
     * @tags devices
     * @name ExecuteDeviceCommands
     * @request POST:/devices/{deviceId}/commands
     * @secure
     */
    executeDeviceCommands: (deviceId: string, localApiCommandBatch: LocalApiCommandBatch, params: RequestParams = {}) =>
      this.request<RespCommandResults, ErrorResponse>({
        path: `/devices/${deviceId}/commands`,
        method: 'POST',
        body: localApiCommandBatch,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Open the commissioning window for a second-ecosystem commissioner to onboard a Matter device.
     *
     * @tags devices
     * @name CreateMatterCommissioningWindow
     * @request POST:/devices/{deviceId}/matter/commissioningWindow
     * @secure
     */
    createMatterCommissioningWindow: (
      deviceId: string,
      createMatterCommissioningWindowRequest: CreateMatterCommissioningWindowRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateMatterCommissioningWindowResponse, ErrorResponse>({
        path: `/devices/${deviceId}/matter/commissioningWindow`,
        method: 'POST',
        body: createMatterCommissioningWindowRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Close the commissioning window in a Matter device.
     *
     * @tags devices
     * @name DeleteMatterCommissioningWindow
     * @request DELETE:/devices/{deviceId}/matter/commissioningWindow
     * @secure
     */
    deleteMatterCommissioningWindow: (deviceId: string, params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/devices/${deviceId}/matter/commissioningWindow`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Read the fabric information from a Matter device.
     *
     * @tags devices
     * @name GetMatterFabrics
     * @request GET:/devices/{deviceId}/matter/fabrics
     * @secure
     */
    getMatterFabrics: (deviceId: string, params: RequestParams = {}) =>
      this.request<MatterFabricList, ErrorResponse>({
        path: `/devices/${deviceId}/matter/fabrics`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve information about the specified fabric from a Matter device.
     *
     * @tags devices
     * @name GetMatterFabric
     * @request GET:/devices/{deviceId}/matter/fabrics/{fabricIndex}
     * @secure
     */
    getMatterFabric: (deviceId: string, fabricIndex: number, params: RequestParams = {}) =>
      this.request<FabricDescriptor, ErrorResponse>({
        path: `/devices/${deviceId}/matter/fabrics/${fabricIndex}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Update a Matter device's label for the selected fabric.  Only the hub-connected fabric is writable.
     *
     * @tags devices
     * @name PartialUpdateMatterFabric
     * @request PATCH:/devices/{deviceId}/matter/fabrics/{fabricIndex}
     * @secure
     */
    partialUpdateMatterFabric: (
      deviceId: string,
      fabricIndex: number,
      partialUpdateMatterFabricRequest: PartialUpdateMatterFabricRequest,
      params: RequestParams = {},
    ) =>
      this.request<object, ErrorResponse>({
        path: `/devices/${deviceId}/matter/fabrics/${fabricIndex}`,
        method: 'PATCH',
        body: partialUpdateMatterFabricRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Remove the specified fabric from a Matter device.  Removal of the hub-connected fabric is not permitted.
     *
     * @tags devices
     * @name DeleteMatterFabric
     * @request DELETE:/devices/{deviceId}/matter/fabrics/{fabricIndex}
     * @secure
     */
    deleteMatterFabric: (deviceId: string, fabricIndex: number, params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/devices/${deviceId}/matter/fabrics/${fabricIndex}`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  matter = {
    /**
     * @description Discover Matter nodes on a given fabric.
     *
     * @tags matter
     * @name PostMatterFabricOperationalServiceEnumeration
     * @request POST:/matter/fabrics/{compressedFabricId}/operationalServiceEnumeration
     * @secure
     */
    postMatterFabricOperationalServiceEnumeration: (compressedFabricId: string, params: RequestParams = {}) =>
      this.request<CreateMatterFabricOperationalServiceEnumerationResponse, ErrorResponse>({
        path: `/matter/fabrics/${compressedFabricId}/operationalServiceEnumeration`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create and return a Certificate Signing Request for the Hub to join a Matter fabric as an administrator for the purpose of migrating nodes on the fabric to the hub's current, active fabric.
     *
     * @tags matter
     * @name PostMatterNodeMigrationCsr
     * @request POST:/matter/nodeMigration/certificateSigningRequest
     * @secure
     */
    postMatterNodeMigrationCsr: (params: RequestParams = {}) =>
      this.request<CreateMatterNodeMigrationCsrResponse, ErrorResponse>({
        path: `/matter/nodeMigration/certificateSigningRequest`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve the record for a specific node migration fabric that the hub administers.
     *
     * @tags matter
     * @name GetMatterNodeMigrationFabric
     * @request GET:/matter/nodeMigration/fabrics/{compressedFabricId}
     * @secure
     */
    getMatterNodeMigrationFabric: (compressedFabricId: string, params: RequestParams = {}) =>
      this.request<GetMatterNodeMigrationFabricResponse, ErrorResponse>({
        path: `/matter/nodeMigration/fabrics/${compressedFabricId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Install a node migration fabric on a hub.  A node migration fabric is a fabric that a hub temporarily administers in order to migrate nodes to its primary, active fabric.  A certificate signing request with public key matching that in the enclosed NOC must have been previously created in order for the request to succeed.
     *
     * @tags matter
     * @name PostMatterNodeMigrationFabric
     * @request POST:/matter/nodeMigration/fabrics/{compressedFabricId}
     * @secure
     */
    postMatterNodeMigrationFabric: (
      compressedFabricId: string,
      createNodeMigrationFabricRequest: CreateMatterNodeMigrationFabricRequest,
      params: RequestParams = {},
    ) =>
      this.request<object, ErrorResponse>({
        path: `/matter/nodeMigration/fabrics/${compressedFabricId}`,
        method: 'POST',
        body: createNodeMigrationFabricRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Create a resource to migrate the client-specified Matter nodes to the hub's primary fabric.
     *
     * @tags matter
     * @name PostMatterNodeMigration
     * @request POST:/matter/nodeMigration/migrations
     * @secure
     */
    postMatterNodeMigration: (
      createMatterNodeMigrationRequest: CreateMatterNodeMigrationRequest,
      params: RequestParams = {},
    ) =>
      this.request<CreateMatterNodeMigrationResponse, ErrorResponse>({
        path: `/matter/nodeMigration/migrations`,
        method: 'POST',
        body: createMatterNodeMigrationRequest,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Poll a node migration resource to view status of nodes as they are commissioned to the hub's primary fabric.
     *
     * @tags matter
     * @name GetMatterNodeMigrationStatus
     * @request GET:/matter/nodeMigration/migrations/{migrationId}
     * @secure
     */
    getMatterNodeMigrationStatus: (migrationId: string, params: RequestParams = {}) =>
      this.request<GetMatterNodeMigrationStatusResponse, ErrorResponse>({
        path: `/matter/nodeMigration/migrations/${migrationId}`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  thread = {
    /**
     * @description Retrieve the hub's Thread network information.
     *
     * @tags thread
     * @name GetThreadNetworkInfo
     * @request GET:/thread/networkInfo
     * @secure
     */
    getThreadNetworkInfo: (params: RequestParams = {}) =>
      this.request<ThreadNetworkInfo, ErrorResponse>({
        path: `/thread/networkInfo`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Join the hub's border router to provided Thread network.
     *
     * @tags thread
     * @name JoinThreadNetwork
     * @request POST:/thread/networkInfo
     * @secure
     */
    joinThreadNetwork: (ThreadNetworkJoinInfo: ThreadNetworkJoinInfo, params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/thread/networkInfo`,
        method: 'POST',
        body: ThreadNetworkJoinInfo,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Reset the hub's thread network information, which includes detaching from current network and forming a new one.
     *
     * @tags thread
     * @name ResetThreadNetwork
     * @request DELETE:/thread/networkInfo
     * @secure
     */
    resetThreadNetwork: (params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/thread/networkInfo`,
        method: 'DELETE',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Retrieve the active Thread operational data set from the hub.
     *
     * @tags thread
     * @name GetThreadOperationalDataSet
     * @request GET:/thread/operationalDataSet
     * @secure
     */
    getThreadOperationalDataSet: (params: RequestParams = {}) =>
      this.request<ThreadOperationalDataSet, ErrorResponse>({
        path: `/thread/operationalDataSet`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Initiate discovery of Thread border routers advertising the _meshcop._udp DNS-SD service.
     *
     * @tags thread
     * @name GetThreadBorderRouterScan
     * @request GET:/thread/borderRouterScan
     * @secure
     */
    getThreadBorderRouterScan: (params: RequestParams = {}) =>
      this.request<ThreadBorderRouterScanResults, ErrorResponse>({
        path: `/thread/borderRouterScan`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
  replace = {
    /**
     * @description Prepare a source hub for replacement
     *
     * @tags replace
     * @name PostReplacePrepareSource
     * @request POST:/replace/prepareSource
     * @secure
     */
    postReplacePrepareSource: (params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/replace/prepareSource`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Prepare a destination hub for replacement
     *
     * @tags replace
     * @name PostReplacePrepareDest
     * @request POST:/replace/prepareDest
     * @secure
     */
    postReplacePrepareDest: (params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/replace/prepareDest`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Request that a source hub perform an immediate backup and send the backup to the cloud
     *
     * @tags replace
     * @name PutStartBackup
     * @request PUT:/replace/startBackup
     * @secure
     */
    putStartBackup: (params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/replace/startBackup`,
        method: 'PUT',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Request a destination hub fetch a backup for application
     *
     * @tags replace
     * @name PostFetchBackup
     * @request POST:/replace/fetchBackup
     * @secure
     */
    postFetchBackup: (backupArgs: CreateReplaceFetchBackupRequest, params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/replace/fetchBackup`,
        method: 'POST',
        body: backupArgs,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Get the status of an existing replace on a destination hub
     *
     * @tags replace
     * @name GetReplaceStatus
     * @request GET:/replace/status
     * @secure
     */
    getReplaceStatus: (params: RequestParams = {}) =>
      this.request<GetReplaceStatusResponseBody, ErrorResponse>({
        path: `/replace/status`,
        method: 'GET',
        secure: true,
        format: 'json',
        ...params,
      }),

    /**
     * @description Stop an ongoing replacement
     *
     * @tags replace
     * @name PostStopReplacement
     * @request POST:/replace/stop
     * @secure
     */
    postStopReplacement: (errorDetails: PostStopReplacementPayload, params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/replace/stop`,
        method: 'POST',
        body: errorDetails,
        secure: true,
        type: ContentType.Json,
        format: 'json',
        ...params,
      }),

    /**
     * @description Apply an already fetched/validated backup to a destination hub
     *
     * @tags replace
     * @name PostApplyBackup
     * @request POST:/replace/applyBackup
     * @secure
     */
    postApplyBackup: (params: RequestParams = {}) =>
      this.request<object, ErrorResponse>({
        path: `/replace/applyBackup`,
        method: 'POST',
        secure: true,
        format: 'json',
        ...params,
      }),
  };
}
